import WorkoutAssignmentModal from './WorkoutAssignmentModal';

export default WorkoutAssignmentModal;
